var render, staticRenderFns
import script from "./customer_user_item.vue?vue&type=script&lang=js"
export * from "./customer_user_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8b59ed8')) {
      api.createRecord('c8b59ed8', component.options)
    } else {
      api.reload('c8b59ed8', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/customer_user/customer_user_item.vue"
export default component.exports